import React from 'react';
import SignIn from 'components/TVE/SignIn';
import { block } from './helper';

function CTAAnonymousSecondary() {
  return (
    <div className={`${block}__anonymous-secondary`}>
      <SignIn />
    </div>
  );
}

CTAAnonymousSecondary.propTypes = {};

CTAAnonymousSecondary.defaultProps = {};

export default CTAAnonymousSecondary;
